import React, { useState, useEffect } from 'react';
import { busApi } from '../../services/api/busApi';

function PartidasParada({ stopId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!stopId) return;

    const fetchDepartures = async () => {
      setLoading(true);
      setData(null);
      try {
        const response = await busApi.getStopDepartures(stopId);
        setData(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchDepartures();
  }, [stopId]);

  return (
    <div className="partidas-parada-container">
      <button onClick={onClose} className="close-button">×</button>
      
      {loading && <p>Carregando próximos ônibus...</p>}
      
      {data && (
        <div>
          <h4>Próximos ônibus em:</h4>
          <p className="stop-name">{data.stops[0]?.name || `Parada ID: ${stopId}`}</p>
          <ul className="departures-list">
            {data.trips.length > 0 ? data.trips.map(trip => (
              <li key={trip.tripId}>
                <div className="trip-info">
                  <span className="linha-badge" style={{borderColor: trip.color, color: trip.color}}>{trip.shortName}</span>
                  <span className="headsign">Sentido: {trip.headsign}</span>
                </div>
                <div className="time-info">
                  Chega às: <strong>{trip.departures[0]?.time.substring(0, 5)}</strong>
                </div>
              </li>
            )) : <p>Nenhum ônibus previsto no momento.</p>}
          </ul>
        </div>
      )}
    </div>
  );
}

export default PartidasParada;